import { keepPreviousData, useQuery } from '@tanstack/react-query';

import { STALE_TIMES } from '#lib/queryConstants';

import { listEmailTemplates, previewEmailTemplate } from '../../api/emailTemplatesApi';

import { emailTemplatesKeys } from './keys';

export function useEmailTemplates() {
	return useQuery({
		queryKey: emailTemplatesKeys.list(),
		queryFn: async () => {
			const res = await listEmailTemplates();
			return res?.templates ?? [];
		},
		staleTime: STALE_TIMES.STANDARD,
	});
}

/**
 * Editor text rendered for one recipient; disabled until a recipient is chosen.
 * @param {{emailSubject: string, emailContent: string, recipient: {crmContactId?: string, crmCompanyId?: string}|null}} params
 * @returns {import('@tanstack/react-query').UseQueryResult}
 */
export function useEmailTemplatePreview({ emailSubject, emailContent, recipient }) {
	const ref = recipient?.crmContactId
		? { crmContactId: recipient.crmContactId }
		: { crmCompanyId: recipient?.crmCompanyId };
	return useQuery({
		queryKey: emailTemplatesKeys.preview({ emailSubject, emailContent, ...ref }),
		queryFn: () => previewEmailTemplate({ emailSubject, emailContent, ...ref }),
		enabled: Boolean(recipient),
		staleTime: STALE_TIMES.FREQUENT,
		placeholderData: keepPreviousData,
	});
}
